var _path, _path2, _path3, _path4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSmallGoogleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.3322 10.1848C18.3423 9.61167 18.2818 9.03857 18.1541 8.48193H10.1692V11.5747H14.8573C14.6792 12.6715 14.0507 13.6464 13.1198 14.2788L13.103 14.3809L15.6269 16.2979L15.8016 16.3143C17.4047 14.8618 18.3322 12.7242 18.3322 10.1848Z",
    fill: "#4285F4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1692 18.3333C12.4645 18.3333 14.3935 17.5922 15.8016 16.3143L13.1198 14.2755C12.2494 14.8486 11.2177 15.1384 10.1725 15.1088C7.96793 15.0956 6.01875 13.6991 5.33318 11.6438L5.23236 11.6537L2.60769 13.6431L2.57408 13.7353C4.01244 16.558 6.95301 18.3366 10.1692 18.3333Z",
    fill: "#34A853"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M5.32982 11.6471C5.14498 11.1168 5.04752 10.5602 5.04752 9.99698C5.05088 9.43706 5.14498 8.88042 5.32309 8.34684L5.31973 8.23815L2.66146 6.21582L2.57408 6.25534C1.36424 8.61034 1.36424 11.3836 2.57408 13.7386L5.32982 11.6471Z",
    fill: "#FBBC05"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.1692 4.88848C11.3891 4.86872 12.5653 5.31337 13.4559 6.13021L15.8554 3.8345C14.3162 2.41821 12.2763 1.64419 10.1658 1.66725C6.94968 1.66725 4.0091 3.44255 2.56738 6.26195L5.3164 8.35345C6.00869 6.29819 7.96123 4.90166 10.1692 4.88848Z",
    fill: "#EB4335"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallGoogleIcon);
export default __webpack_public_path__ + "static/media/smallGoogleIcon.18ea42884e0c6ebefb712a0b2adb8583.svg";
export { ForwardRef as ReactComponent };